import React from 'react';
import PropTypes from 'prop-types';

import columns from './Columns';
import Title from '../../Title';
import List from '../shared/List';
import Filters from '../../../main/reports/filters/FiltersContainer';
import ExportableReport from '../../../main/reports/ExportableReport';

const ValuationReport = props => (
  <div>
    <Title namespace="report">Valuation report</Title>
    <div className="c-wrapper o-page-height">
      <Filters
        csv={props.downloadCsv}
        disableBarberFilter
        showCsvExport={props.canLoadReport}
      />
      <ExportableReport
        canLoadReport={props.canLoadReport}
        name="product-inventory-valuation-report"
        label="Valuation report"
      >
        <List items={props.report} columns={columns} />
      </ExportableReport>
    </div>
  </div>
);

ValuationReport.propTypes = {
  downloadCsv: PropTypes.func.isRequired,
  canLoadReport: PropTypes.bool.isRequired,
  report: PropTypes.array.isRequired,
};

export default ValuationReport;
